module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-italic-pro-e813afdcaba7ed6159e7f7fe65d60ba4.woff2";